// Remove local token manager and always use the global one
document.addEventListener('DOMContentLoaded', function() {
    let bonusOfferList = document.getElementById('bonus-offer__list');
    if (bonusOfferList) {
        bonusOfferList.setAttribute('data-pagination', '12');
    }
});

// Add this global variable to store page cursors
const pageCursors = {};
const bonusOfferList = document.getElementById('bonus-offer__list');
const postPerPage = bonusOfferList.getAttribute('data-pagination') || 4;

// Add this global variable to store total items estimate
const storeInfo = {
  totalItems: 0,
  estimatedPages: 0
};

// Add filter options object to store available filter values
const filterOptions = {
  brands: [],
  categories: [],
  brandLabels: {},
  categoryLabels: {}
};

// Add this global variable to store all fetched data
const appState = {
  allMetaobjects: [],
  filteredMetaobjects: [],
  currentPage: 1,
  itemsPerPage: postPerPage, // default, will be updated from DOM
  filters: {
    brand: [],
    category: []
  }
};

// Add mobile UI state variables
const uiState = {
  isFilterOpen: false
};

// Modify layout constants to remove min-height values
const layoutConstants = {
  loadingDelay: 300 // milliseconds for minimum loading time to prevent flashing
};

// Add utility functions for debounce and throttle to prevent flickering
// IMPORTANT: Define this before any functions that use it
const utilityFunctions = {
  // Debounce function to prevent rapid firing of events
  debounce: (func, delay) => {
    let debounceTimer;
    return function(...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(this, args), delay);
    };
  },

  // Throttle function to limit the rate of function execution
  throttle: (func, limit) => {
    let inThrottle;
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
};

// Add utility function to convert between GID and clean ID
const urlUtils = {
  // Convert GID to clean ID for URL
  gidToCleanId: (gid) => {
    if (typeof gid === 'string') {
      // Handle Brand GIDs
      if (gid.startsWith('gid://shopify/Brand/')) {
        return gid.replace('gid://shopify/Brand/', '');
      }
      // Handle Category GIDs
      if (gid.startsWith('gid://shopify/Category/')) {
        return gid.replace('gid://shopify/Category/', '');
      }
      // Handle Collection GIDs (legacy support)
      if (gid.startsWith('gid://shopify/Collection/')) {
        return gid.replace('gid://shopify/Collection/', '');
      }
    }
    return gid;
  },

  // Convert clean ID back to Brand GID
  cleanIdToBrandGid: (cleanId) => {
    if (typeof cleanId === 'string' && !cleanId.startsWith('gid://')) {
      return `gid://shopify/Brand/${cleanId}`;
    }
    return cleanId;
  },

  // Convert clean ID back to Category GID
  cleanIdToCategoryGid: (cleanId) => {
    if (typeof cleanId === 'string' && !cleanId.startsWith('gid://')) {
      return `gid://shopify/Category/${cleanId}`;
    }
    return cleanId;
  }
};

// Add a global variable to track our initial data processing
let initialDataProcessing = null;

// Function to process metaobjects data from Liquid (replaces fetchMetaobjects)
function processMetaobjectsData() {
  try {
    // Get data from Liquid that was injected into the page
    const metaobjectsData = window.METAOBJECT_DATA;

    if (!metaobjectsData) {
      console.warn('No metaobject data available from Liquid');
      return {
        metaobjects: {
          edges: []
        }
      };    }

    // Handle different possible data structures from Liquid
    let dataArray = [];

    if (Array.isArray(metaobjectsData)) {
      dataArray = metaobjectsData;
    } else if (metaobjectsData.values && Array.isArray(metaobjectsData.values)) {
      dataArray = metaobjectsData.values;
    } else if (metaobjectsData.edges && Array.isArray(metaobjectsData.edges)) {
      // Already in GraphQL format
      return {
        metaobjects: metaobjectsData
      };
    } else {
      console.warn('Unexpected metaobject data structure:', metaobjectsData);
      return {
        metaobjects: {
          edges: []
        }
      };    }

    // Transform the Liquid data to match the expected GraphQL format
    const transformedData = {      metaobjects: {
        edges: dataArray.map((metaobject, index) => {
          // The metaobject from Liquid should have properties directly
          // We need to convert them to the fields format that the rest of the code expects
          const fields = [];// Convert metaobject properties to fields array
          if (metaobject && typeof metaobject === 'object') {
            Object.keys(metaobject).forEach(key => {
              // Skip system properties and ensure we have valid values
              if (!['id', 'handle', 'type', 'created_at', 'updated_at'].includes(key) &&
                metaobject[key] !== null &&
                metaobject[key] !== undefined) {
                const value = metaobject[key];
                let fieldType = 'single_line_text_field';
                let processedValue = value;
                // Handle special field structures from Liquid
                if (typeof value === 'object' && value !== null) {
                  if (value.type === 'rich_text_field') {
                    fieldType = 'rich_text_field';
                  } else if (value.reference) {
                    fieldType = 'file_reference';
                  } else if (value.id && value.title) {
                    // Handle brand/category objects with direct id and title properties
                    // For brand/category: { id: "gid://shopify/Brand/123", title: "Brand Name" } → "gid://shopify/Brand/123"
                    processedValue = value.id; // Use the ID for filtering
                    fieldType = 'collection_reference';
                  } else if (value.value) {
                    // Handle other objects with .value property
                    if (typeof value.value === 'object' && value.value.title) {
                      processedValue = value.value.title;
                      fieldType = 'collection_reference';
                    } else {
                      processedValue = value.value;
                    }
                  }
                } else if (typeof value === 'string' && value.match(/^\d{4}-\d{2}-\d{2}/)) {
                  fieldType = 'date';
                }

                fields.push({
                  key: key,
                  value: processedValue,
                  type: fieldType,
                  // Store original object for reference if needed
                  ...(typeof value === 'object' && value !== null && value.value ? { originalValue: value } : {})
                });
              }
            });
          }
          // Ensure we always have at least an empty fields array
          if (!Array.isArray(fields)) {
            fields = [];
          }

          const processedNode = {
            node: {
              id: metaobject.id || `temp-${Math.random()}`,
              handle: metaobject.handle || '',
              fields: fields || [] // Ensure fields is always an array
            }
          };

          return processedNode;
        })
      }    };

    return transformedData;
  } catch (error) {
    console.error('Error processing metaobjects data:', error);
    // Return empty structure to prevent further errors
    return {
      metaobjects: {
        edges: []
      }
    };
  }
}

// Function to extract brand and category data directly from metaobject data
function extractBrandCategoryData(metaobjectsData) {
  const brandMap = {};
  const categoryMap = {};

  if (Array.isArray(metaobjectsData)) {
    metaobjectsData.forEach((offer) => {
      // Extract brand data if available
      if (offer.brand && offer.brand.id && offer.brand.title) {
        brandMap[offer.brand.id] = offer.brand.title;
      }

      // Extract category data if available
      if (offer.category && offer.category.id && offer.category.title) {
        categoryMap[offer.category.id] = offer.category.title;
      }
    });
  }

  return { brandMap, categoryMap };
}

// Update the extractFilterOptions function to use direct brand/category data
function extractFilterOptions(metaobjects) {
  const brands = new Set();
  const categories = new Set();

  // Extract brand and category data directly from the original metaobject data
  const { brandMap, categoryMap } = extractBrandCategoryData(window.METAOBJECT_DATA);

  if (metaobjects && metaobjects.edges && Array.isArray(metaobjects.edges)) {
    metaobjects.edges.forEach((edge) => {
      const fields = {};
      if (edge.node && edge.node.fields && Array.isArray(edge.node.fields)) {
        edge.node.fields.forEach((field) => {
          if (field && field.key && field.value) {
            fields[field.key] = field.value;
          }
        });
      }

      // For brand field, check if we have brand data in the original metaobject
      if (fields.brand) {
        brands.add(fields.brand);
      }

      // For category field, check if we have category data in the original metaobject
      if (fields.category) {
        categories.add(fields.category);
      }
    });
  }

  filterOptions.brands = Array.from(brands).sort();
  filterOptions.categories = Array.from(categories).sort();

  // Initialize label maps using the direct brand/category data
  filterOptions.brandLabels = {};
  filterOptions.categoryLabels = {};

  // Map brand GIDs to their titles using the direct data
  filterOptions.brands.forEach(brandGid => {
    if (brandMap[brandGid]) {
      filterOptions.brandLabels[brandGid] = brandMap[brandGid];
    } else {
      filterOptions.brandLabels[brandGid] = brandGid;
    }
  });

  // Map category GIDs to their titles using the direct data
  filterOptions.categories.forEach(categoryGid => {
    if (categoryMap[categoryGid]) {
      filterOptions.categoryLabels[categoryGid] = categoryMap[categoryGid];
    } else {
      filterOptions.categoryLabels[categoryGid] = categoryGid;
    }
  });

  return Promise.resolve();
}

// Add utility function to manage the single loading container
const loadingManager = {
  show: (message = 'Loading promotions...') => {
    const container = document.querySelector('.bonus-offer__loading-container');
    if (container) {
      const messageElement = container.querySelector('p');
      if (messageElement) {
        messageElement.textContent = message;
      }
      container.style.display = 'flex';
      container.style.opacity = '1';
    }
  },

  hide: () => {
    const container = document.querySelector('.bonus-offer__loading-container');
    if (container) {
      container.style.opacity = '0';
      setTimeout(() => {
        container.style.display = 'none';
      }, 300);
    }
  }
};

// New function to process all metaobjects at once (replaces fetchAllMetaobjects)
async function processAllMetaobjects() {
  try {
    // Show loading using the single container
    loadingManager.show();

    // Process data from Liquid
    const data = processMetaobjectsData();

    if (!data || !data.metaobjects) {
      console.warn('No metaobjects data available');
      // Show empty state
      const listContainer = document.querySelector('.bonus-offer__list');
      if (listContainer) {
        listContainer.innerHTML = `
          <div class="no-results" style="display: flex; align-items: center; justify-content: center; padding: 40px;">
            <p>No promotions available at this time.</p>
          </div>
        `;
      }
      loadingManager.hide();
      return Promise.resolve(data);
    }

    // Store all processed metaobjects
    appState.allMetaobjects = data.metaobjects.edges || [];
    appState.filteredMetaobjects = [...appState.allMetaobjects];

    // Extract filter options (this is async because it may fetch collection details)
    await extractFilterOptions(data.metaobjects);

    // Update total count
    storeInfo.totalItems = appState.allMetaobjects.length;

    // Add a small delay for better UX (simulate loading)
    return new Promise(resolve => {
      setTimeout(() => {
        loadingManager.hide();
        resolve(data.metaobjects);
      }, layoutConstants.loadingDelay);
    });
  } catch (error) {
    console.error('Error processing all metaobjects:', error);
    const listContainer = document.querySelector('.bonus-offer__list');
    if (listContainer) {
      listContainer.innerHTML = `
        <div class="error-message" style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z" fill="currentColor"/>
          </svg>
          <p>There was an error loading the promotions. Please try again later.</p>
        </div>
      `;
    }
    loadingManager.hide();
    throw error;
  }
}

// Replace loadPage with improved version that handles clean URLs
function loadPage(page = 1) {
  // Force page to be at least 1
  page = Math.max(1, page);

  // Save current page
  appState.currentPage = page;

  // Update URL to reflect current state - use clean IDs for URL
  const searchParams = new URLSearchParams();
  searchParams.set('page', page.toString());

  // Add filter params with clean IDs using comma-separated values
  Object.entries(appState.filters).forEach(([key, values]) => {
    if (values.length > 0) {
      // Use Set to avoid duplicates and join with commas
      const uniqueValues = [...new Set(values)];
      const cleanValues = uniqueValues.map(value => urlUtils.gidToCleanId(value));
      searchParams.set(key, cleanValues.join(','));
    }
  });

  window.history.replaceState({}, '', `?${searchParams.toString()}`);

  // Calculate pagination slices
  const startIndex = (page - 1) * appState.itemsPerPage;
  const endIndex = startIndex + appState.itemsPerPage;

  // Get current page items
  const pageItems = appState.filteredMetaobjects.slice(startIndex, endIndex);

  // Create page info for rendering pagination
  const pageInfo = {
    hasNextPage: endIndex < appState.filteredMetaobjects.length,
    hasPreviousPage: page > 1,
    startCursor: startIndex > 0 ? String(startIndex) : null,
    endCursor: endIndex < appState.filteredMetaobjects.length ? String(endIndex) : null
  };

  // Show loading state before updating content
  loadingManager.show();

  // Add a small delay before updating content
  setTimeout(() => {
    // Render the current page items
    if (pageItems.length === 0) {
      const listContainer = document.querySelector('.bonus-offer__list');
      const contentContainer = document.querySelector('.bonus-offer__content');
      if (listContainer) {
        listContainer.innerHTML = `
          <div class="no-results">
            No promotions available.
          </div>
        `;
      }
      if (contentContainer) {
        contentContainer.classList.add('no-promotions');
      }
    } else {
      // Create a metaobjects structure similar to what the API would return
      const metaobjects = {
        edges: pageItems,
        pageInfo: pageInfo
      };

      renderMetaobjects(metaobjects);
    }
    // Always update statistics and pagination based on filteredMetaobjects length
    renderStatistics(appState.filteredMetaobjects.length, page);
    renderPagination(pageInfo, page);

    // Render the filter UI
    renderFilterUI(appState.filters);

    // Update filter visibility based on available offers
    toggleFilterVisibility();

    // Remove any filtering visual state
    const listContainer = document.querySelector('.bonus-offer__list');
    if (listContainer) {
      listContainer.classList.remove('is-filtering');
    }

    // Hide loading
    loadingManager.hide();
  }, 100); // Minimum delay to ensure loading is visible
}

// Define applyFiltersWithDebounce ONCE - Remove all other declarations
const applyFiltersWithDebounce = utilityFunctions.debounce((expandedSections = {}) => {
  // Show loading with filter-specific message and ensure minimum visibility
  loadingManager.show();

  // Add visual feedback for filtering
  const listContainer = document.querySelector('.bonus-offer__list');
  if (listContainer) {
    listContainer.classList.add('is-filtering');
  }

  // Collect all checked brand filters
  const brandCheckboxes = document.querySelectorAll('input[name="brand"]:checked');
  const brandValues = [...new Set(Array.from(brandCheckboxes).map((cb) => cb.value))];

  // Collect all checked category filters
  const categoryCheckboxes = document.querySelectorAll('input[name="category"]:checked');
  const categoryValues = [...new Set(Array.from(categoryCheckboxes).map((cb) => cb.value))];

  // Update app state filters
  appState.filters = {
    brand: brandValues,
    category: categoryValues
  };

  // Apply filters to all metaobjects
  if (brandValues.length > 0 || categoryValues.length > 0) {
    appState.filteredMetaobjects = appState.allMetaobjects.filter((edge) => {
      const fields = {};

      // Create a map of fields for easy access
      if (edge.node && edge.node.fields && Array.isArray(edge.node.fields)) {
        edge.node.fields.forEach((field) => {
          if (field && field.key && field.value) {
            fields[field.key] = field.value;
          }
        });
      }

      // Check if this metaobject matches all active filters
      let matchesBrand = true;
      let matchesCategory = true;

      if (brandValues.length > 0) {
        matchesBrand = brandValues.includes(fields.brand);
      }

      if (categoryValues.length > 0) {
        matchesCategory = categoryValues.includes(fields.category);
      }

      return matchesBrand && matchesCategory;
    });
  } else {
    // No filters active, show all items
    appState.filteredMetaobjects = [...appState.allMetaobjects];
  }

  // Update URL with filters using clean IDs - start with fresh URLSearchParams
  const searchParams = new URLSearchParams();

  // Use Set to avoid duplicates, then add filter values to URL with clean IDs
  const uniqueBrands = [...new Set(brandValues)];
  const uniqueCategories = [...new Set(categoryValues)];

  // Add comma-separated values to URL
  if (uniqueBrands.length > 0) {
    const cleanBrands = uniqueBrands.map(brand => urlUtils.gidToCleanId(brand));
    searchParams.set('brand', cleanBrands.join(','));
  }

  if (uniqueCategories.length > 0) {
    const cleanCategories = uniqueCategories.map(category => urlUtils.gidToCleanId(category));
    searchParams.set('category', cleanCategories.join(','));
  }

  // Reset to page 1 when filters change
  searchParams.set('page', '1');
  appState.currentPage = 1;

  // Use replaceState instead of pushState to avoid adding to browser history on each filter
  window.history.replaceState({}, '', `?${searchParams.toString()}`);

  // Ensure minimum loading time for better UX and visual feedback
  setTimeout(() => {
    // Remove filtering visual state
    const listContainer = document.querySelector('.bonus-offer__list');
    if (listContainer) {
      listContainer.classList.remove('is-filtering');
    }

    // Reload the first page with new filters, preserving expanded sections
    loadPage(1);

    // Update filter visibility based on available offers
    toggleFilterVisibility();

    // Restore expanded state after page load
    setTimeout(() => {
      const brandSection = document.getElementById('brand-filters');
      const categorySection = document.getElementById('category-filters');

      if (brandSection && expandedSections.brand) {
        brandSection.classList.add('show-all');
        const button = document.querySelector('button[data-target="brand-filters"]');
        if (button) button.classList.add('showing-all');
      }

      if (categorySection && expandedSections.category) {
        categorySection.classList.add('show-all');
        const button = document.querySelector('button[data-target="category-filters"]');
        if (button) button.classList.add('showing-all');
      }
    }, 10);
  }, 300); // Minimum loading time for better UX
}, 300); // 300ms debounce delay

// Replace the existing applyFilters function with the debounced version
function applyFilters(expandedSections = {}) {
  applyFiltersWithDebounce(expandedSections);
}

// This function starts the data processing as early as possible
function initiateEarlyDataProcessing() {
  // Start processing immediately and store the promise
  initialDataProcessing = processAllMetaobjects().catch(error => {
    console.error('Early data processing failed:', error);
    // We'll handle the error display when rendering
    return null;
  });
  return initialDataProcessing;
}

// Start the data processing immediately when the script loads
initiateEarlyDataProcessing();

// Update loadAllItems to handle comma-separated values
function loadAllItems() {
  const searchParams = new URLSearchParams(window.location.search);

  // Parse comma-separated filter parameters
  const brandFilters = searchParams.get('brand')?.split(',').filter(Boolean) || [];
  const categoryFilters = searchParams.get('category')?.split(',').filter(Boolean) || [];

  // Clear the params and rebuild them
  searchParams.delete('brand');
  searchParams.delete('category');
  searchParams.delete('page');

  // Set pageView=all
  searchParams.set('pageView', 'all');

  // Add back all filter parameters with clean IDs
  brandFilters.forEach(brand => {
    searchParams.append('brand', brand);
  });

  categoryFilters.forEach(category => {
    searchParams.append('category', category);
  });

  // Update URL with all parameters
  window.history.pushState({}, '', `?${searchParams.toString()}`);

  // // Show loading state
  loadingManager.show();

  // Apply a small delay to ensure loading indicator is visible
  setTimeout(() => {
    // Show all items without pagination
    if (appState.filteredMetaobjects.length === 0) {
      const listContainer = document.querySelector('.bonus-offer__list');
      if (listContainer) {
        listContainer.innerHTML = `
          <div class="no-results" style="display: flex; align-items: center; justify-content: center;">
            No promotions available.
          </div>
        `;
      }
      const contentContainer = document.querySelector('.bonus-offer__content');
      if (contentContainer) {
        contentContainer.classList.add('no-promotions');
      }
    } else {
      // Create a metaobjects structure for rendering
      const metaobjects = {
        edges: appState.filteredMetaobjects,
        pageInfo: {
          hasNextPage: false,
          hasPreviousPage: false
        }
      };

      renderMetaobjects(metaobjects);
    }

    // Always render statistics with accurate filtered count
    renderStatistics(appState.filteredMetaobjects.length, 'all');

    // Update filter visibility based on available offers
    toggleFilterVisibility();

    // Hide pagination
    const paginationContainer = document.querySelector('.bonus-offer__pagination');
    if (paginationContainer) {
      paginationContainer.style.display = 'none';
    }

    // Hide loading
    loadingManager.hide();
  }, 300); // Slight delay for better UX
}

// Update the DOMContentLoaded event handler to handle clean URLs from the browser
document.addEventListener('DOMContentLoaded', async () => {
  try {
    const container = document.querySelector('.bonus-offer__container');
    if (!container) {
      console.error('Container .bonus-offer__container not found');
      return;
    }

    // Get pagination setting from DOM
    const bonusOfferList = document.getElementById('bonus-offer__list');
    if (bonusOfferList) {
      const paginationSetting = bonusOfferList.getAttribute('data-pagination');
      if (paginationSetting) {
        appState.itemsPerPage = parseInt(paginationSetting, 10) || 4;
      }
    }

    // Check if pagination container exists, create if needed
    if (!document.querySelector('.bonus-offer__pagination')) {
      const paginationDiv = document.createElement('div');
      paginationDiv.classList.add('bonus-offer__pagination');
      container.appendChild(paginationDiv);
    }

    // Check if stats container exists, create if needed
    if (!document.querySelector('.bonus-offer__stats')) {
      const statsDiv = document.createElement('div');
      statsDiv.classList.add('bonus-offer__stats');

      // Insert stats before pagination
      const pagination = document.querySelector('.bonus-offer__pagination');
      if (pagination && pagination.parentNode) {
        pagination.parentNode.insertBefore(statsDiv, pagination);
      } else {
        // Fallback: append to container if pagination not found
        container.appendChild(statsDiv);
      }
    }

    // Check if filter container exists (it should already be in the HTML)
    // If not found, create it at the beginning of the container
    if (!document.querySelector('.bonus-offer__filter')) {
      const filterDiv = document.createElement('div');
      filterDiv.classList.add('bonus-offer__filter');

      // Insert as first child if container has children, otherwise just append
      if (container.firstChild) {
        container.insertBefore(filterDiv, container.firstChild);
      } else {
        container.appendChild(filterDiv);
      }
    }

    // Read URL params for initial state and convert clean IDs back to GIDs
    const searchParams = new URLSearchParams(window.location.search);
    appState.currentPage = parseInt(searchParams.get('page')) || 1;

    // Initialize filters from URL, handling comma-separated values
    const brandParam = searchParams.get('brand');
    const categoryParam = searchParams.get('category');

    appState.filters = {
      brand: brandParam ? brandParam.split(',').map(brand => urlUtils.cleanIdToBrandGid(brand)) : [],
      category: categoryParam ? categoryParam.split(',').map(category => urlUtils.cleanIdToCategoryGid(category)) : []
    };

    // Use the data that was already being processed
    let metaobjectsData;
    if (initialDataProcessing) {
      metaobjectsData = await initialDataProcessing;
    } else {
      // If for some reason the early processing didn't happen, do it now
      metaobjectsData = await processAllMetaobjects();
    }

    // IMPORTANT: First initialize the filter UI with the data, then apply any filters
    // Ensure all metaobjects are filtered properly based on URL parameters
    if (appState.filters.brand.length > 0 || appState.filters.category.length > 0) {
      // Apply the filters but don't re-render yet (we'll do that below)
      appState.filteredMetaobjects = appState.allMetaobjects.filter((edge) => {
        const fields = {};

        if (edge.node && edge.node.fields && Array.isArray(edge.node.fields)) {
          edge.node.fields.forEach((field) => {
            if (field && field.key && field.value) {
              fields[field.key] = field.value;
            }
          });
        }

        let matchesBrand = true;
        let matchesCategory = true;

        if (appState.filters.brand.length > 0) {
          matchesBrand = appState.filters.brand.includes(fields.brand);
        }

        if (appState.filters.category.length > 0) {
          matchesCategory = appState.filters.category.includes(fields.category);
        }

        return matchesBrand && matchesCategory;
      });
    } else {
      // No filters active, show all items
      appState.filteredMetaobjects = [...appState.allMetaobjects];
    }

    // Check if pageView=all is specified first
    if (searchParams.get('pageView') === 'all') {
      loadAllItems();
    } else {
      // Otherwise load the current page with filtered metaobjects
      loadPage(appState.currentPage);
    }

    // Always render the filter UI with the correct state, regardless of pageView mode
    renderFilterUI(appState.filters);

    // Initialize filter sections
    initializeFilterSections();

    // Hide filter if there are no offers
    toggleFilterVisibility();

  } catch (error) {
    console.error('Error during initialization:', error);
    document.querySelector('.bonus-offer__list').innerHTML = `
      <div class="error-message">
        There was an error initializing the page. Please try again later.<br>
      </div>
    `;
  }
});

// Add utility function to hide/show filter based on filter options availability
function toggleFilterVisibility() {
  const filterElement = document.querySelector('.bonus-offer__filter');
  const filterToggleElement = document.querySelector('.bonus-offer__filter-toggle');

  if (!filterElement) return;

  // Check if there are any offers available (check all offers, not just filtered ones)
  const hasOffers = appState.allMetaobjects && appState.allMetaobjects.length > 0;

  // Check if there are any categories or brands available for filtering
  const hasBrands = filterOptions.brands && filterOptions.brands.length > 0;
  const hasCategories = filterOptions.categories && filterOptions.categories.length > 0;
  const hasFilterOptions = hasBrands || hasCategories;

  // Show filter only if there are offers AND there are filter options (brands or categories)
  if (hasOffers && hasFilterOptions) {
    filterElement.style.display = '';
    if (filterToggleElement) {
      filterToggleElement.style.display = '';
    }
  } else {
    filterElement.style.display = 'none';
    if (filterToggleElement) {
      filterToggleElement.style.display = 'none';
    }
  }
}

// Update renderPagination to work with client-side pagination
function renderPagination(pageInfo, currentPage) {
  const paginationContainer = document.querySelector('.bonus-offer__pagination');
  if (!paginationContainer) return;

  paginationContainer.innerHTML = '';
  paginationContainer.style.display = ''; // Show pagination by default

  // Calculate total pages
  const totalPages = Math.ceil(appState.filteredMetaobjects.length / appState.itemsPerPage);

  if (totalPages <= 1) {
    // Hide pagination if only one page
    paginationContainer.style.display = 'none';
    return;
  }

  // Create pagination container
  const paginationNav = document.createElement('nav');
  paginationNav.className = 'pagination';
  paginationNav.setAttribute('role', 'navigation');
  paginationNav.setAttribute('aria-label', 'Pagination');

  const paginationList = document.createElement('ul');
  paginationList.className = 'pagination-list';

  // Previous button
  if (currentPage > 1) {
    const prevItem = document.createElement('li');
    const prevLink = document.createElement('a');
    prevLink.className = 'pagination-previous';
    prevLink.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                              <mask id="mask0_4947_10945" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                                <rect y="0.277832" width="24" height="24" fill="#D9D9D9"/>
                              </mask>
                              <g mask="url(#mask0_4947_10945)">
                                <path d="M9.95185 17.9315L4.29785 12.2778L9.95185 6.62402L11.0056 7.70852L7.18635 11.5278H19.7019V13.0278H7.18635L11.0056 16.847L9.95185 17.9315Z" fill="#F68628"/>
                              </g>
                            </svg>
                          `;
    prevLink.href = '#';
    prevLink.addEventListener('click', (e) => {
      e.preventDefault();
      loadPage(currentPage - 1);
    });
    prevItem.appendChild(prevLink);
    paginationList.appendChild(prevItem);
  }

  // Page numbers
  const startPage = Math.max(1, Math.min(currentPage - 2, totalPages - 4));
  const endPage = Math.min(totalPages, Math.max(5, currentPage + 2));

  for (let i = startPage; i <= endPage; i++) {
    const pageItem = document.createElement('li');
    const pageLink = document.createElement('a');
    pageLink.className = 'pagination-link';
    pageLink.textContent = i.toString();
    if (i === currentPage) {
      pageLink.className += ' is-current';
      pageLink.setAttribute('aria-current', 'page');
    } else {
      pageLink.href = '#';
      pageLink.addEventListener('click', (e) => {
        e.preventDefault();
        loadPage(i);
      });
    }

    pageItem.appendChild(pageLink);
    paginationList.appendChild(pageItem);
  }

  // Next button
  if (pageInfo.hasNextPage) {
    const nextItem = document.createElement('li');
    const nextLink = document.createElement('a');
    nextLink.className = 'pagination-next';
    nextLink.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                              <mask id="mask0_4947_10959" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                                <rect y="0.277832" width="24" height="24" fill="#D9D9D9"/>
                              </mask>
                              <g mask="url(#mask0_4947_10959)">
                                <path d="M13.8462 17.9315L12.7923 16.847L16.6115 13.0278H4.5V11.5278H16.6115L12.7923 7.70852L13.8462 6.62402L19.5 12.2778L13.8462 17.9315Z" fill="#F68628"/>
                              </g>
                            </svg>
                          `;
    nextLink.href = '#';
    nextLink.addEventListener('click', (e) => {
      e.preventDefault();
      loadPage(currentPage + 1);
    });
    nextItem.appendChild(nextLink);
    paginationList.appendChild(nextItem);
  }

  paginationNav.appendChild(paginationList);
  paginationContainer.appendChild(paginationNav);
}

// Function to render rich text content
function renderRichText(richText) {
  try {
    if (!richText) return '';

    let richTextData;

    // Handle if the input is already an object
    if (typeof richText === 'object') {
      richTextData = richText;
    } else {
      // Try to parse as JSON
      try {
        richTextData = JSON.parse(richText);
      } catch (e) {
        // If not valid JSON, return as-is
        return String(richText);
      }
    }

    // Handle specific structure from the API
    if (richTextData && richTextData.type === 'root' && Array.isArray(richTextData.children)) {
      return richTextData.children.map(node => {
        // Handle paragraphs
        if (node.type === 'paragraph') {
          const content = (node.children || []).map(child => {
            // Handle text nodes
            if (child.type === 'text') {
              return child.value;
            }
            // Handle links
            else if (child.type === 'link' && child.url) {
              const linkText = (child.children || [])
                .map(linkChild => linkChild.value || '')
                .join('');
              return `<a href="${child.url}" target="_blank" rel="noopener">${linkText}</a>`;
            }
            return '';
          }).join('');

          return `<p>${content}</p>`;
        }
        // Handle headings
        else if (node.type && node.type.startsWith('heading')) {
          const level = node.depth || parseInt(node.type.charAt(node.type.length - 1)) || 2;
          const content = (node.children || [])
            .map(child => child.value || '')
            .join('');
          return `<h${level}>${content}</h${level}>`;
        }
        // Handle lists
        else if (node.type === 'list') {
          const listType = node.ordered ? 'ol' : 'ul';
          const listItems = (node.children || []).map(item => {
            if (item.type === 'listItem') {
              const itemContent = (item.children || [])
                .map(itemChild => {
                  if (itemChild.type === 'paragraph') {
                    return (itemChild.children || [])
                      .map(paraChild => paraChild.value || '')
                      .join('');
                  }
                  return '';
                })
                .join('');
              return `<li>${itemContent}</li>`;
            }
            return '';
          }).join('');
          return `<${listType}>${listItems}</${listType}>`;
        }

        return '';
      }).join('');
    }

    // Fallback to string representation
    return typeof richTextData === 'string'
      ? richTextData
      : JSON.stringify(richTextData);

  } catch (error) {
    console.warn('Error rendering rich text:', error);
    return String(richText || ''); // Safe fallback
  }
}

// Fix the formatDate function (remove duplicate)
function formatDate(dateString) {
  try {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  } catch (error) {
    console.warn('Error formatting date:', dateString, error);
    return dateString; // Return the original string if formatting fails
  }
}

// Add missing renderMetaobjects function
function renderMetaobjects(metaobjects) {
  const container = document.querySelector('.bonus-offer__list');
  const contentContainer = document.querySelector('.bonus-offer__content');

  if (!container) {
    console.error('Could not find container element .bonus-offer__list');
    return;
  }

  if (!metaobjects || !metaobjects.edges || metaobjects.edges.length === 0) {
    container.innerHTML = '<div class="no-results">No promotions available.</div>';
    if (contentContainer) {
      contentContainer.classList.add('no-promotions');
    }
    return;
  }

  // Remove no-promotions class if it exists
  if (contentContainer) {
    contentContainer.classList.remove('no-promotions');
  }

  container.innerHTML = '';
  metaobjects.edges.forEach((edge, index) => {

    const metaobject = edge.node;
    const fields = {};

    if (!metaobject.fields || !Array.isArray(metaobject.fields)) {
      console.error(`Metaobject ${index + 1} has no fields array:`, metaobject);
      return;
    }

    metaobject.fields.forEach((field) => {
      if (!field || !field.key) {
        console.warn('Skipping invalid field:', field);
        return;
      }
      fields[field.key] = field.value;

      // Store the field type for special handling during rendering
      fields[`${field.key}_type`] = field.type;
    });

    // Render the metaobject item
    try {
      const itemHtml = `
        <div class="bonus-offer__item" data-id="${metaobject.id || ''}">
          <div class="bonus-offer__item--image">
            ${
        fields.image
          ? `<a href="${fields.url}" title="${
            fields.short_description || ''
          }" class="bonus-offer__item--image-link">
                    <img src="${fields.image}" alt="${fields?.imageAlt || ''}" width="100%" height="auto">
                  </a>`
          : `<a href="${fields.url}" title="${
            fields.short_description || ''
          }" class="bonus-offer__item--image-link"><div class="placeholder-svg"><svg class="placeholder-svg placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"></path><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"></path><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"></path></svg></div></a>`
      }
          </div>
          <div class="bonus-offer__item--content">
            <p class="bonus-offer__item--content-title">
              <a href="${fields.url}">
                ${fields.short_description || 'Untitled Promotion'}
              </a>
            </p>
          </div>
        </div>
      `;
      container.innerHTML += itemHtml;
    } catch (error) {
      console.error(`Error rendering metaobject ${index + 1}:`, error);
    }
  });
}

// Add missing renderStatistics function
function renderStatistics(itemCount, currentPage) {
  let statsContainer = document.querySelector('.bonus-offer__stats');
  if (!statsContainer) {
    statsContainer = document.createElement('div');
    statsContainer.classList.add('bonus-offer__stats');
    const parentContainer = document.querySelector('.bonus-offer__bottom');
    const paginationDiv = document.querySelector('.bonus-offer__pagination');
    if (parentContainer && paginationDiv) {
      parentContainer.insertBefore(statsContainer, paginationDiv);
    }
  }

  // Use itemCount directly since it already contains the filtered count passed from loadPage/loadAllItems
  const displayCount = itemCount;

  // Determine if we should show the View All button
  const showViewAll =
    currentPage !== 'all' && // Not already in View All mode
    displayCount > appState.itemsPerPage; // Have more items than fit on one page

  // Update the UI with the correct count and conditionally show the view all button
  statsContainer.innerHTML = `
   ${showViewAll ? `
    <div class="bonus-offer__stats-actions">
      <button class="bonus-offer__view-all">
        <span>View all</span>
        ${displayCount > 0 ? `
          <div class="bonus-offer__stats-count">
            <span>${displayCount}</span> ${displayCount > 1 ? 'Promotions' : 'Promotion '}
          </div>
        ` : ''}
      </button>
    </div>
    ` : ''}
  `;

  let promotionCountSelector = document.querySelector('.bonus-offer__count-text'),
      promotionToolbarContainer = document.querySelector('.bonus-offer__action-toolbar');
  if (promotionCountSelector) {
    promotionCountSelector.innerHTML = `<span>${displayCount}</span> ${displayCount > 1 ? 'Promotions' : 'Promotion '}`;
    if (promotionToolbarContainer) {
      promotionToolbarContainer.style.display = 'flex';
    }
  }
  const viewAllButton = statsContainer.querySelector('.bonus-offer__view-all');
  if (viewAllButton) {
    viewAllButton.addEventListener('click', () => {
      loadAllItems();

      // Ensure filter UI is rendered after switching to "View All" mode
      setTimeout(() => {
        renderFilterUI(appState.filters);
      }, 300);
    });
  }
}

// Add a function to count items per filter value
function countItemsPerFilterValue() {
  const brandCounts = {};
  const categoryCounts = {};

  // Initialize all possible values with zero counts
  filterOptions.brands.forEach((brand) => (brandCounts[brand] = 0));
  filterOptions.categories.forEach((category) => (categoryCounts[category] = 0));
  // Count occurrences in all metaobjects
  appState.allMetaobjects.forEach((edge) => {
    const fields = {};

    // Safety check to ensure fields exists and is an array
    if (edge.node && edge.node.fields && Array.isArray(edge.node.fields)) {
      edge.node.fields.forEach((field) => {
        fields[field.key] = field.value;
      });
    }

    // Increment brand count if it exists
    if (fields.brand && brandCounts.hasOwnProperty(fields.brand)) {
      brandCounts[fields.brand]++;
    }

    // Increment category count if it exists
    if (fields.category && categoryCounts.hasOwnProperty(fields.category)) {
      categoryCounts[fields.category]++;
    }
  });

  return { brandCounts, categoryCounts };
}

// Update the generateFilterOptions function to include counts
function generateFilterOptions(options, values, labels, counts, type) {
  let optionsHtml = '';
  const MAX_VISIBLE_OPTIONS = 5;
  options.forEach((option, index) => {
    const isVisible = index < MAX_VISIBLE_OPTIONS ? '' : 'hidden-option';
    // Get the count for this option, default to 0 if missing
    const count = counts[option] || 0;

    // Ensure option is a string for HTML generation
    const optionStr = String(option);
    const safeId = optionStr.replace(/\//g, '-').replace(/\s+/g, '-').toLowerCase();

    optionsHtml += `
      <div class="bonus-offer__filter-option ${isVisible}" data-filter-idx="${index}">
        <input type="checkbox" id="${type}-${safeId}"
          name="${type}" value="${option}" ${values.includes(option) ? 'checked' : ''}>
        <label for="${type}-${safeId}">
          ${labels[option] || `Unknown ${type.charAt(0).toUpperCase() + type.slice(1)}`}
          <span class="bonus-offer__filter-count">${count}</span>
        </label>
      </div>
    `;
  });

  // Add a "Show All" button if there are more than MAX_VISIBLE_OPTIONS
  if (options.length > MAX_VISIBLE_OPTIONS) {
    optionsHtml += `
      <div class="bonus-offer__filter-show-more">
        <button type="button" class="bonus-offer__filter-show-all" data-target="${type}-filters">
          <span class="show-text">Show All</span>
          <span class="hide-text">Show Less</span>
        </button>
      </div>
    `;
  }

  return optionsHtml;
}

// Update renderFilterUI to use the counts and preserve expanded state
function renderFilterUI(currentFilters = {}) {
  // Track which filter sections are expanded
  const expandedSections = {};

  // Store the current expansion state before re-rendering
  const brandFiltersElement = document.getElementById('brand-filters');
  const categoryFiltersElement = document.getElementById('category-filters');

  if (brandFiltersElement) {
    expandedSections.brand = brandFiltersElement.classList.contains('show-all');
  }
  if (categoryFiltersElement) {
    expandedSections.category = categoryFiltersElement.classList.contains('show-all');
  }

  const filterContainer = document.querySelector('.bonus-offer__filter');
  if (!filterContainer) {
    console.error('Filter container not found');
    return;
  }

  // Check if mobile filter toggle button exists, create if not
  if (!document.querySelector('.bonus-offer__filter-toggle')) {
    const filterToggle = document.createElement('button');
    filterToggle.className = 'bonus-offer__filter-toggle';
    filterToggle.innerHTML = `<span class="icon-filter">
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <mask id="mask0_5017_14308" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
            <rect x="0.5" width="24" height="24" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_5017_14308)">
            <path d="M12.4998 20.75C12.2871 20.75 12.109 20.6781 11.9655 20.5343C11.8218 20.3906 11.75 20.2125 11.75 20V16C11.75 15.7875 11.8219 15.6094 11.9658 15.4658C12.1096 15.3219 12.2878 15.25 12.5003 15.25C12.7129 15.25 12.891 15.3219 13.0345 15.4658C13.1782 15.6094 13.25 15.7875 13.25 16V17.25H20.5C20.7125 17.25 20.8906 17.3219 21.0343 17.4658C21.1781 17.6096 21.25 17.7878 21.25 18.0003C21.25 18.2129 21.1781 18.391 21.0343 18.5345C20.8906 18.6782 20.7125 18.75 20.5 18.75H13.25V20C13.25 20.2125 13.1781 20.3906 13.0343 20.5343C12.8904 20.6781 12.7122 20.75 12.4998 20.75ZM4.5 18.75C4.2875 18.75 4.10942 18.6781 3.96575 18.5343C3.82192 18.3904 3.75 18.2122 3.75 17.9998C3.75 17.7871 3.82192 17.609 3.96575 17.4655C4.10942 17.3218 4.2875 17.25 4.5 17.25H8.5C8.7125 17.25 8.89058 17.3219 9.03425 17.4658C9.17808 17.6096 9.25 17.7878 9.25 18.0003C9.25 18.2129 9.17808 18.391 9.03425 18.5345C8.89058 18.6782 8.7125 18.75 8.5 18.75H4.5ZM8.49975 14.75C8.28708 14.75 8.109 14.6781 7.9655 14.5343C7.82183 14.3906 7.75 14.2125 7.75 14V12.75H4.5C4.2875 12.75 4.10942 12.6781 3.96575 12.5343C3.82192 12.3904 3.75 12.2122 3.75 11.9998C3.75 11.7871 3.82192 11.609 3.96575 11.4655C4.10942 11.3218 4.2875 11.25 4.5 11.25H7.75V10C7.75 9.7875 7.82192 9.60942 7.96575 9.46575C8.10958 9.32192 8.28775 9.25 8.50025 9.25C8.71292 9.25 8.891 9.32192 9.0345 9.46575C9.17817 9.60942 9.25 9.7875 9.25 10V14C9.25 14.2125 9.17808 14.3906 9.03425 14.5343C8.89042 14.6781 8.71225 14.75 8.49975 14.75ZM12.5 12.75C12.2875 12.75 12.1094 12.6781 11.9658 12.5343C11.8219 12.3904 11.75 12.2122 11.75 11.9998C11.75 11.7871 11.8219 11.609 11.9658 11.4655C12.1094 11.3218 12.2875 11.25 12.5 11.25H20.5C20.7125 11.25 20.8906 11.3219 21.0343 11.4658C21.1781 11.6096 21.25 11.7878 21.25 12.0003C21.25 12.2129 21.1781 12.391 21.0343 12.5345C20.8906 12.6782 20.7125 12.75 20.5 12.75H12.5ZM16.4998 8.75C16.2871 8.75 16.109 8.67808 15.9655 8.53425C15.8218 8.39058 15.75 8.2125 15.75 8V4C15.75 3.7875 15.8219 3.60942 15.9658 3.46575C16.1096 3.32192 16.2878 3.25 16.5003 3.25C16.7129 3.25 16.891 3.32192 17.0345 3.46575C17.1782 3.60942 17.25 3.7875 17.25 4V5.25H20.5C20.7125 5.25 20.8906 5.32192 21.0343 5.46575C21.1781 5.60958 21.25 5.78775 21.25 6.00025C21.25 6.21292 21.1781 6.391 21.0343 6.5345C20.8906 6.67817 20.7125 6.75 20.5 6.75H17.25V8C17.25 8.2125 17.1781 8.39058 17.0343 8.53425C16.8904 8.67808 16.7122 8.75 16.4998 8.75ZM4.5 6.75C4.2875 6.75 4.10942 6.67808 3.96575 6.53425C3.82192 6.39042 3.75 6.21225 3.75 5.99975C3.75 5.78708 3.82192 5.609 3.96575 5.4655C4.10942 5.32183 4.2875 5.25 4.5 5.25H12.5C12.7125 5.25 12.8906 5.32192 13.0343 5.46575C13.1781 5.60958 13.25 5.78775 13.25 6.00025C13.25 6.21292 13.1781 6.391 13.0343 6.5345C12.8906 6.67817 12.7125 6.75 12.5 6.75H4.5Z" fill="#00D0BF"/>
          </g>
      </svg>
      </span><span>Filters</span>`;
    filterToggle.setAttribute('aria-label', 'Toggle filter options');

    // Insert the toggle button at the top of the content
    const contentContainer = document.querySelector('.bonus-offer__action-toolbar');
    if (contentContainer) {
      contentContainer.insertAdjacentElement('afterbegin', filterToggle);
    } else {
      // Fallback: insert before filter container
      filterContainer.parentNode.insertBefore(filterToggle, filterContainer);
    }

    // Add event listener to toggle the filter panel
    filterToggle.addEventListener('click', toggleFilterPanel);
  }

  let inputBrandSearch = document.createElement('input');
    inputBrandSearch.type = 'text';
    inputBrandSearch.id = 'brands-search-input';
    inputBrandSearch.className = 'bonus-offer__brands-search-input';
    inputBrandSearch.placeholder = 'Filter Brands';
    inputBrandSearch.setAttribute('aria-label', 'Filter Brand');

  // Convert string filter values to arrays if needed
  const brandFilters = currentFilters.brand
    ? Array.isArray(currentFilters.brand)
      ? currentFilters.brand
      : [currentFilters.brand]
    : [];

  const categoryFilters = currentFilters.category
    ? Array.isArray(currentFilters.category)
      ? currentFilters.category
      : [currentFilters.category]
    : [];

  // Check if any filters are active
  const hasActiveFilters = brandFilters.length > 0 || categoryFilters.length > 0;

  // Get counts for all filter values
  const { brandCounts, categoryCounts } = countItemsPerFilterValue();

  // Create the filter HTML structure with Apply button for mobile and toggleable sections
  filterContainer.innerHTML = `
    <div class="bonus-offer__filter-header">
      <h4 class="bonus-offer__filter-title">Filters</h4>
      <button class="bonus-offer__filter-close" aria-label="Close filter panel">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <mask id="mask0_5017_7902" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
            <rect x="0.5" width="24" height="24" fill="#D9D9D9"/>
          </mask>
          <g mask="url(#mask0_5017_7902)">
            <path d="M12.5 13.0538L7.42701 18.127C7.28851 18.2653 7.11443 18.3362 6.90476 18.3395C6.69526 18.3427 6.51801 18.2718 6.37301 18.127C6.22818 17.982 6.15576 17.8063 6.15576 17.6C6.15576 17.3937 6.22818 17.218 6.37301 17.073L11.4463 12L6.37301 6.92701C6.23468 6.78851 6.16385 6.61443 6.16051 6.40476C6.15735 6.19526 6.22818 6.01801 6.37301 5.87301C6.51801 5.72818 6.69368 5.65576 6.90001 5.65576C7.10635 5.65576 7.28201 5.72818 7.42701 5.87301L12.5 10.9463L17.573 5.87301C17.7115 5.73468 17.8856 5.66385 18.0953 5.66051C18.3048 5.65735 18.482 5.72818 18.627 5.87301C18.7718 6.01801 18.8443 6.19368 18.8443 6.40001C18.8443 6.60635 18.7718 6.78201 18.627 6.92701L13.5538 12L18.627 17.073C18.7653 17.2115 18.8362 17.3856 18.8395 17.5953C18.8427 17.8048 18.7718 17.982 18.627 18.127C18.482 18.2718 18.3063 18.3443 18.1 18.3443C17.8937 18.3443 17.718 18.2718 17.573 18.127L12.5 13.0538Z" fill="#F68628"/>
          </g>
        </svg>
      </button>
    </div>
    <div class="bonus-offer__filter-content">
    <div class="bonus-offer__filter-section">
        <div class="bonus-offer__filter-section-header" data-target="category-filters">
          <label class="bonus-offer__filter-section-title">Category</label>
          <span class="bonus-offer__filter-section-toggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <mask id="mask0_4947_15222" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                <rect y="0.5" width="24" height="24" fill="#F68628"/>
              </mask>
              <g mask="url(#mask0_4947_15222)">
                <path d="M11.9999 10.9538L7.39994 15.5538L6.34619 14.5L11.9999 8.84625L17.6537 14.5L16.5999 15.5538L11.9999 10.9538Z" fill="#F68628"/>
              </g>
            </svg>
          </span>
        </div>
        <div class="bonus-offer__filter-options" id="category-filters">
          ${generateFilterOptions(
      filterOptions.categories,
      categoryFilters,
      filterOptions.categoryLabels,
      categoryCounts,
      'category'
  )}
        </div>
      </div>
      <div class="bonus-offer__filter-section">
        <div class="bonus-offer__filter-section-header" data-target="brand-filters">
          <label class="bonus-offer__filter-section-title">Brand</label>
          <span class="bonus-offer__filter-section-toggle">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <mask id="mask0_4947_15222" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
                <rect y="0.5" width="24" height="24" fill="#F68628"/>
              </mask>
              <g mask="url(#mask0_4947_15222)">
                <path d="M11.9999 10.9538L7.39994 15.5538L6.34619 14.5L11.9999 8.84625L17.6537 14.5L16.5999 15.5538L11.9999 10.9538Z" fill="#F68628"/>
              </g>
            </svg>
          </span>
        </div>
        <div class="bonus-offer__filter-options" id="brand-filters">
          <div class="bonus-offer__brands-search">
            <label for="brands-search-input" class="bonus-offer__brands-search-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_6191_10964)">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M15 17.25C19.5563 17.25 23.25 13.5563 23.25 9C23.25 4.44365 19.5563 0.75 15 0.75C10.4437 0.75 6.75 4.44365 6.75 9C6.75 13.5563 10.4437 17.25 15 17.25ZM15 14.25C17.8995 14.25 20.25 11.8995 20.25 9C20.25 6.1005 17.8995 3.75 15 3.75C12.1005 3.75 9.75 6.1005 9.75 9C9.75 11.8995 12.1005 14.25 15 14.25Z" fill="#00D0BF"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9171 2.73438C16.6128 2.73438 18.2072 3.39473 19.4063 4.59387C20.6054 5.79296 21.2658 7.38728 21.2658 9.08307C21.2658 10.7789 20.6054 12.3732 19.4063 13.5723C18.2072 14.7714 16.6128 15.4318 14.9171 15.4318C13.2213 15.4318 11.6269 14.7714 10.4279 13.5723C9.22876 12.3732 8.56836 10.7789 8.56836 9.08307C8.56836 7.38728 9.22871 5.79296 10.4279 4.59387C11.6269 3.39477 13.2213 2.73438 14.9171 2.73438ZM14.9063 13.9688C17.5987 13.9688 19.7813 11.7862 19.7813 9.0938C19.7813 6.40141 17.5987 4.2188 14.9063 4.2188C12.2139 4.2188 10.0313 6.40141 10.0313 9.0938C10.0313 11.7862 12.2139 13.9688 14.9063 13.9688Z" fill="#064A45"/>
                  <path d="M21.3391 2.66034C19.6236 0.944777 17.3427 0 14.9165 0C12.4903 0 10.2094 0.944777 8.49382 2.66034C6.77826 4.37586 5.83348 6.65684 5.83348 9.08297C5.83348 10.5119 6.16155 11.8902 6.78141 13.1326L0.844294 19.0697C-0.282082 20.1961 -0.282082 22.0288 0.844294 23.1552C1.40746 23.7184 2.14724 24 2.88703 24C3.62681 24 4.3666 23.7183 4.92976 23.1552L10.8669 17.2181C12.1092 17.838 13.4876 18.166 14.9165 18.166C17.3427 18.166 19.6236 17.2212 21.3391 15.5057C23.0547 13.7901 23.9995 11.5092 23.9995 9.08302C23.9995 6.65689 23.0547 4.3759 21.3391 2.66034ZM3.93331 22.1587C3.35639 22.7356 2.41767 22.7357 1.84074 22.1587C1.26381 21.5818 1.26381 20.6431 1.84074 20.0662L7.53228 14.3746C7.81914 14.7731 8.13978 15.1516 8.49387 15.5057C8.84791 15.8597 9.22637 16.1804 9.6249 16.4672L3.93331 22.1587ZM20.3427 14.5092C18.8933 15.9586 16.9662 16.7568 14.9165 16.7568C12.8667 16.7568 10.9396 15.9586 9.49023 14.5092C8.04081 13.0599 7.24264 11.1328 7.24264 9.08302C7.24264 7.03324 8.04086 5.1062 9.49023 3.65679C10.9396 2.20738 12.8668 1.4092 14.9165 1.4092C16.9662 1.4092 18.8933 2.20742 20.3427 3.65679C21.7921 5.10615 22.5903 7.03324 22.5903 9.08302C22.5903 11.1328 21.7921 13.0598 20.3427 14.5092Z" fill="#064A45"/>
                </g>
                <defs>
                  <clipPath id="clip0_6191_10964">
                    <rect width="24" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </label>
            ${inputBrandSearch.outerHTML}
          </div>
          ${generateFilterOptions(filterOptions.brands, brandFilters, filterOptions.brandLabels, brandCounts, 'brand')}
        </div>
      </div>

      <div class="bonus-offer__filter-actions ${hasActiveFilters ? 'show' : ''}">
        <button type="button" class="bonus-offer__filter-apply button button--primary">Apply</button>
        <button type="button" class="bonus-offer__filter-clear button button--small button--primary">Clear Filters</button>
      </div>
    </div>
  `;

  // Add event listeners to checkboxes (don't auto-apply on mobile)
  const checkboxes = filterContainer.querySelectorAll('input[type="checkbox"]');

  // For desktop, we'll keep the auto-filter behavior but preserve expanded state
  if (window.innerWidth > 768) {
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', utilityFunctions.throttle(() => {
        // Store current expanded state before applying filters
        const brandSection = document.getElementById('brand-filters');
        const categorySection = document.getElementById('category-filters');

        if (brandSection) {
          expandedSections.brand = brandSection.classList.contains('show-all');
        }
        if (categorySection) {
          expandedSections.category = categorySection.classList.contains('show-all');
        }

        // Apply filters with throttling
        applyFilters(expandedSections);
      }, 200)); // 200ms throttle
    });
  }
  // Clear filters button
  const clearButton = filterContainer.querySelector('.bonus-offer__filter-clear');
  clearButton.addEventListener('click', () => {
    // Show loading for clear action with visual feedback
    loadingManager.show();

    // Add visual feedback for filtering
    const listContainer = document.querySelector('.bonus-offer__list');
    if (listContainer) {
      listContainer.classList.add('is-filtering');
    }

    // Uncheck all filter checkboxes
    const allCheckboxes = filterContainer.querySelectorAll('input[type="checkbox"]');
    allCheckboxes.forEach(checkbox => {
      checkbox.checked = false;
    });

    // Reset filters in app state
    appState.filters = {
      brand: [],
      category: []
    };

    // Reset to all metaobjects
    appState.filteredMetaobjects = [...appState.allMetaobjects];

    // Update URL without reloading the page - use clean URL format
    const searchParams = new URLSearchParams();
    searchParams.set('page', '1');
    window.history.pushState({}, '', `?${searchParams.toString()}`);

    // Reset to page 1 and reload content with smooth transition
    appState.currentPage = 1;

    // Use setTimeout to ensure smooth transition and minimum loading visibility
    setTimeout(() => {
      // Remove filtering visual state
      if (listContainer) {
        listContainer.classList.remove('is-filtering');
      }

      loadPage(1);

      // Close filter panel on mobile
      if (window.innerWidth <= 768) {
        toggleFilterPanel(null, false);
      }
    }, 600); // Increased delay to ensure loading spinner is visible
  });
  // Apply filters button (mainly for mobile)
  const applyButton = filterContainer.querySelector('.bonus-offer__filter-apply');
  applyButton.addEventListener('click', () => {
    // Show loading before applying filters
    loadingManager.show();

    // Add visual feedback
    const listContainer = document.querySelector('.bonus-offer__list');
    if (listContainer) {
      listContainer.classList.add('is-filtering');
    }

    // Apply filters with a slight delay to ensure loading is visible
    setTimeout(() => {
      applyFilters();
      toggleFilterPanel(null, false); // Close the panel after applying
    }, 200);
  });

  // Close button
  const closeButton = filterContainer.querySelector('.bonus-offer__filter-close');
  closeButton.addEventListener('click', () => {
    toggleFilterPanel(null, false); // Force close
  });

  // Add event listeners to section headers to toggle content
  const sectionHeaders = filterContainer.querySelectorAll('.bonus-offer__filter-section-header');
  sectionHeaders.forEach((header) => {
    header.addEventListener('click', () => {
      toggleFilterSection(header);
    });
  });

  // Add event listeners to "Show All" buttons
  const showAllButtons = filterContainer.querySelectorAll('.bonus-offer__filter-show-all');
  showAllButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const targetId = this.getAttribute('data-target');
      const optionsContainer = document.getElementById(targetId);

      if (!optionsContainer) return;

      const isExpanded = optionsContainer.classList.contains('show-all');

      if (isExpanded) {
        // Hide extra options
        optionsContainer.classList.remove('show-all');
        this.classList.remove('showing-all');
      } else {
        // Show all options
        optionsContainer.classList.add('show-all');
        this.classList.add('showing-all');
      }
    });
  });

  // Restore expanded state
  setTimeout(() => {
    const brandSection = document.getElementById('brand-filters');
    const categorySection = document.getElementById('category-filters');

    if (brandSection && expandedSections.brand) {
      brandSection.classList.add('show-all');
      const button = filterContainer.querySelector('button[data-target="brand-filters"]');
      if (button) button.classList.add('showing-all');
    }

    if (categorySection && expandedSections.category) {
      categorySection.classList.add('show-all');
      const button = filterContainer.querySelector('button[data-target="category-filters"]');
      if (button) button.classList.add('showing-all');
    }
  }, 0);

  let inputBrandHTML = filterContainer.querySelector('#brands-search-input'),
      showMoreBtn = filterContainer.querySelector('#brand-filters .bonus-offer__filter-show-more'),
      brandOptions = filterContainer.querySelectorAll('#brand-filters .bonus-offer__filter-option');
   inputBrandHTML.addEventListener('input', function() {
    const MAX_VISIBLE_OPTIONS = 5;
    utilityFunctions.debounce(() => {
      const searchTerm = this.value.toLowerCase();
      let visibleCount = 0;
      brandOptions.forEach((option, index) => {
        const isVisible = index < MAX_VISIBLE_OPTIONS ? '' : 'hidden-option';
        const label = option.querySelector('label');
        if (label && searchTerm) {
          const labelText = label.childNodes[0].textContent.toLowerCase().trim();
          if (labelText.includes(searchTerm)) {
            option.classList.add('matched');
            option.classList.remove('no-matched');
            visibleCount++;
          } else {
            option.classList.remove('matched')
            option.classList.add('no-matched')
          }
        }
        else {
          option.classList.remove('matched');
          option.classList.remove('no-matched')
        }
      });
      if (searchTerm) {
        // Limit the number of visible options
        if (visibleCount >= MAX_VISIBLE_OPTIONS && searchTerm) {
          showMoreBtn.style.display = 'block';
        } else {
          showMoreBtn.style.display = 'none';
        }
      } else {
        showMoreBtn.style.display = 'block';
      }

    }, 300)();
  });
  updateFilterPanelState();
}

// Function to toggle filter section visibility
function toggleFilterSection(headerElement) {
  const targetId = headerElement.getAttribute('data-target');
  const targetSection = document.getElementById(targetId);

  if (!targetSection) return;

  const isCollapsed = targetSection.classList.contains('collapsed');
  const toggleIcon = headerElement.querySelector('.bonus-offer__filter-section-toggle');

  // Store SVG icons for expand/collapse states
  const expandIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
  <mask id="mask0_4947_15222" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
    <rect y="0.5" width="24" height="24" fill="#F68628"/>
  </mask>
  <g mask="url(#mask0_4947_15222)">
    <path d="M11.9999 10.9538L7.39994 15.5538L6.34619 14.5L11.9999 8.84625L17.6537 14.5L16.5999 15.5538L11.9999 10.9538Z" fill="#F68628"/>
  </g>
</svg>`;

  const collapseIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1306_29627" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="-1" width="24" height="25">
      <rect y="-0.5" width="24" height="24" fill="#F68628"/>
    </mask>
    <g mask="url(#mask0_1306_29627)">
      <path d="M11.9999 9.95375L7.39994 14.5538L6.34619 13.5L11.9999 7.84625L17.6537 13.5L16.5999 14.5538L11.9999 9.95375Z" fill="#F68628"/>
    </g>
  </svg>`;

  if (isCollapsed) {
    // Expand the section
    targetSection.classList.remove('collapsed');
    headerElement.setAttribute('aria-expanded', 'true');
    if (toggleIcon) {
      toggleIcon.innerHTML = expandIcon;
      toggleIcon.setAttribute('aria-label', 'Collapse section');
    }
  } else {
    // Collapse the section
    targetSection.classList.add('collapsed');
    headerElement.setAttribute('aria-expanded', 'false');
    if (toggleIcon) {
      toggleIcon.innerHTML = collapseIcon;
      toggleIcon.setAttribute('aria-label', 'Expand section');
    }
  }
}

// Function to toggle filter panel visibility
function toggleFilterPanel(event, forceState) {
  // If force state is provided, use it; otherwise toggle current state
  uiState.isFilterOpen = forceState !== undefined ? forceState : !uiState.isFilterOpen;
  updateFilterPanelState();

  // If opening the panel, create an overlay
  if (uiState.isFilterOpen) {
    createFilterOverlay();
  } else {
    removeFilterOverlay();
  }
}

// Function to update the filter panel state based on uiState
function updateFilterPanelState() {
  const filterContainer = document.querySelector('.bonus-offer__filter');
  const body = document.body;

  if (uiState.isFilterOpen) {
    filterContainer.classList.add('is-active');
    body.classList.add('filter-open'); // Prevent scrolling
  } else {
    filterContainer.classList.remove('is-active');
    body.classList.remove('filter-open');
  }
}

// Create overlay when filter is open on mobile
function createFilterOverlay() {
  // Remove existing overlay if any
  removeFilterOverlay();

  // Create new overlay
  const overlay = document.createElement('div');
  overlay.className = 'bonus-offer__filter-overlay';
  overlay.addEventListener('click', () => {
    toggleFilterPanel(null, false); // Close panel when overlay is clicked
  });

  document.body.appendChild(overlay);

  // Animate in
  setTimeout(() => {
    overlay.classList.add('is-active');
  }, 10);
}

// Remove overlay
function removeFilterOverlay() {
  const overlay = document.querySelector('.bonus-offer__filter-overlay');
  if (overlay) {
    overlay.classList.remove('is-active');
    // Wait for animation before removing
    setTimeout(() => {
      overlay.parentNode.removeChild(overlay);
    }, 300);
  }
}

// Function to initialize filter sections
function initializeFilterSections() {
  const sectionHeaders = document.querySelectorAll('.bonus-offer__filter-section-header');

  sectionHeaders.forEach(header => {
    const targetId = header.getAttribute('data-target');
    const targetSection = document.getElementById(targetId);

    if (targetSection) {
      // Set initial state
      header.setAttribute('aria-expanded', 'true');
      targetSection.classList.remove('collapsed');

      // Add click handler
      header.addEventListener('click', () => toggleFilterSection(header));
    }
  });
}
